import styled from "styled-components";
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import './style.css'
import { updatePedidoWithEntregador, getEntregadores } from "../../services/api";
import AsyncSelect from "react-select/async";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const DivPedidoContainer = styled.div`
  z-index:15;
  position: fixed;
  top: 0;
  left: 0;
  display: ${({ showModalAddEntregador }) => (showModalAddEntregador ? 'none' : 'flex')};
  float: left;
  min-width: 100%;
  min-height: 100%;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  padding: 5px 0;
  list-style: none;
  background-color: rgba(0,0,0,0.5);
  background-clip: padding-box;
  align-items:center;
  justify-content:center;
  opacity: ${({ showModalAddEntregador }) => (showModalAddEntregador ? '0' : '1')};
  transition: opacity .3s ease-in-out;

  // Add keyframes for the fade-in effect
  animation: fadeIn .3s ease-in-out;
  animation-fill-mode: forwards;

  // Define the keyframes for the animation
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const DivPedido = styled.div`
    z-index: 20;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 480px;
    max-width: 520px;
    width: 90vw;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 20px;
    box-shadow: 
        0 25px 50px rgba(0, 0, 0, 0.15),
        0 10px 25px rgba(0, 0, 0, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(20px);
    overflow: hidden;
    animation: modalFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    @keyframes modalFadeIn {
        from {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
    }

    @media (max-width: 768px) {
        min-width: 340px;
        max-width: 440px;
        width: 95vw;
        border-radius: 16px;
    }
`;

const ModalAddEntregador = ({
    showModalAddEntregador,
    setShowModalAddEntregador,
    pedidoToAddEntregador,
    objIdEmpresa,
    userID,
    setRefresh
}) => {
    const { t } = useTranslation('orders');

    const closeModalAddEntregador = () => {
        setShowModalAddEntregador(!showModalAddEntregador);
    }

    const saveModalAddAddEntregador = () => {
        handleSaveEntregador();
        setShowModalAddEntregador(!showModalAddEntregador);
    }

    const [selectData, setSelectData] = useState({
        value: '',
        label: t('driverModal.selectPlaceholder'),
    });

    useEffect(() => {
        if (pedidoToAddEntregador && pedidoToAddEntregador.entregador) {
          const entregador = pedidoToAddEntregador.entregador;
          setSelectData({
            value: entregador,
            label: `${entregador.name} | ${entregador.veiculo}`,
          });
        } else {
          setSelectData({
            value: '',
            label: t('driverModal.selectPlaceholder'),
          });
        }
    }, [pedidoToAddEntregador, t]);

    const mapResponseToValuesAndLabels = (data) => ({
        value: data,
        label: data.name + " | " + data.veiculo,
    });

    async function callApi(value) {
        const data = await getEntregadores(objIdEmpresa)
        .then((response) => response.data.entregadores)//response.json())
        .then((response) => response.sort((a, b) => a.order - b.order )) // Adicione esta linha para ordenar os dados
        .then((response) => response.map(mapResponseToValuesAndLabels))
        .then((response) => response.filter((i) => i.label.toLowerCase().includes(value.toLowerCase())) );
  
        return data;
    }

    const handleSaveEntregador = async () => {
        if (!selectData.value) {
          toast.error(t('driverModal.toasts.selectRequired'));
          return;
        }

        try {
          await updatePedidoWithEntregador(pedidoToAddEntregador._id, selectData.value);
          toast.success(t('driverModal.toasts.success'));
          setRefresh(true);
          setShowModalAddEntregador(!showModalAddEntregador);
        } catch (error) {
          toast.error(t('driverModal.toasts.error'));
        }
    };

    return (
        <DivPedidoContainer showModalAddEntregador={showModalAddEntregador}>
            <DivPedido>
                <div className="pedeja-entregador-modal-header">
                    <div className="pedeja-entregador-title-section">
                        <h2 className="pedeja-entregador-modal-title">{t('driverModal.title')}</h2>
                        <p className="pedeja-entregador-modal-subtitle">{t('driverModal.orderNumber', { number: pedidoToAddEntregador?.id_pedido_counter || pedidoToAddEntregador?.id_pedido })}</p>
                    </div>
                    <button className="pedeja-entregador-close-btn" onClick={() => closeModalAddEntregador()}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={20}
                            height={20}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <line x1={18} y1={6} x2={6} y2={18} />
                            <line x1={6} y1={6} x2={18} y2={18} />
                        </svg>
                    </button>
                </div>

                <div className="pedeja-entregador-modal-content">
                    <div className="pedeja-entregador-select-container">
                        <AsyncSelect
                            cacheOptions
                            loadOptions={callApi}
                            onChange={(data) => {
                                setSelectData(data);
                            }}
                            value={selectData}
                            defaultOptions
                            placeholder={t('driverModal.selectPlaceholder')}
                            className="pedeja-entregador-async-select"
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    height: "52px",
                                    minHeight: "52px",
                                    border: "2px solid #e2e8f0",
                                    borderRadius: "12px",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                                    transition: "all 0.2s ease",
                                    "&:hover": {
                                        borderColor: "#28a745"
                                    }
                                }),
                                input: (style) => ({
                                    ...style,
                                    color: "#2d3748",
                                    fontSize: "16px",
                                }),
                                singleValue: (baseStyles) => ({
                                    ...baseStyles,
                                    color: selectData.value ? "#2d3748" : "#a0aec0",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                }),
                                placeholder: (baseStyles) => ({
                                    ...baseStyles,
                                    color: "#a0aec0",
                                    fontSize: "16px",
                                }),
                                option: (styles, { isFocused, isSelected }) => ({
                                    ...styles,
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    color: isSelected ? "white" : "#2d3748",
                                    backgroundColor: isSelected ? "#28a745" : isFocused ? "#f7fafc" : "white",
                                    padding: "12px 16px",
                                    cursor: "pointer"
                                }),
                                menu: (baseStyles) => ({
                                    ...baseStyles,
                                    borderRadius: "12px",
                                    border: "2px solid #e2e8f0",
                                    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
                                }),
                                menuList: (baseStyles) => ({
                                    ...baseStyles,
                                    borderRadius: "12px",
                                    padding: "8px 0",
                                }),
                            }}
                        />
                    </div>
                </div>

                <div className="pedeja-entregador-modal-footer">
                    <button className="pedeja-entregador-btn-secondary" onClick={() => closeModalAddEntregador()}>
                        {t('driverModal.cancel')}
                    </button>
                    <button className="pedeja-entregador-btn-primary" onClick={() => saveModalAddAddEntregador()}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {t('driverModal.save')}
                    </button>
                </div>

            </DivPedido>
        </DivPedidoContainer>
    )
}

export default ModalAddEntregador;